import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 2 }

import Column from 'primevue/column'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faArrowDown, faArrowUp } from 'fontawesome/pro-regular-svg-icons'
import Skeleton from 'primevue/skeleton'

interface Props {
    field: string
    header: string
    loading: boolean
    extraClass?: string
    centred?: boolean
    loadingWidth?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderboardTableColumn',
  props: {
    field: {},
    header: {},
    loading: { type: Boolean },
    extraClass: {},
    centred: { type: Boolean },
    loadingWidth: {}
  },
  setup(__props: any) {

const props = __props

const pt = {
    headerCell: { class: 'fm-table__header' },
    columnTitle: { class: 'fm-table__header__column-title' },
    columnHeaderContent: { class: 'fm-table__header__content' },
    sort: { class: 'fm-table__header__sort' },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Column), _mergeProps(_ctx.$attrs, {
    field: _ctx.field,
    header: _ctx.header,
    pt: pt,
    sortable: true,
    class: [
            'fm-table__column',
            _ctx.extraClass ? `fm-table__column--${_ctx.extraClass}` : '',
            { 'fm-table__column--centred': _ctx.centred },
        ]
  }), {
    sorticon: _withCtx(({ sorted, sortOrder }) => [
      (sorted && sortOrder === 1)
        ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
            key: 0,
            icon: _unref(faArrowUp),
            "aria-label": "Sorted ascending"
          }, null, 8, ["icon"]))
        : (sorted && sortOrder === -1)
          ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
              key: 1,
              icon: _unref(faArrowDown),
              "aria-label": "Sorted descending"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
    ]),
    body: _withCtx((slotProps) => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_unref(Skeleton), {
            key: 0,
            width: _ctx.loadingWidth ?? '100%',
            "data-testid": "loading",
            height: "16px"
          }, null, 8, ["width"]))
        : (_ctx.$slots.body)
          ? _renderSlot(_ctx.$slots, "body", _normalizeProps(_mergeProps({ key: 1 }, slotProps)))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.data[_ctx.field] ?? ''), 1))
    ]),
    _: 3
  }, 16, ["field", "header", "class"]))
}
}

})